import styled from 'styled-components';

export const BoldText = styled.span`
  font-weight: 600;
`;
